<template>
  <div class="hw-header-wrap">
    <header class="hw-header header">
      <div class="bb-container-max">
        <div class="hw-header__container header__container">
          <div class="hw-header__logo header__logo">
            <router-link :to="logoLink" aria-current="page">
              <img
                src="../../assets/img/logos/logo-hellowish-dark.webp"
                alt="Logo HelloBB"
                v-show="logoScope === 'hellowish'"
              />
              <img
                src="../../assets/img/logos/logo-hellobb-dark.svg"
                alt="Logo HelloBB"
                v-show="logoScope === 'hellobb'"
              />
            </router-link>
          </div>

          <div class="hw-header__nav hw-header__nav--desktop">
            <HeaderNav :headerLang="headerLang" :headerType="headerType" />
          </div>

          <div class="hw-header__right header__right">
            <div class="hw-header__user hw-header__user--desktop">
              <HeaderUser :headerLang="headerLang" />
            </div>

            <div
              class="hw-header__hucha header__hucha"
              v-if="showLittlePig && !hidePiggyBank"
            >
              <router-link to="/contributions">
                <img
                  class="hw-header__icon header-nav-icon"
                  src="../../assets/img/ico/ico-nav-hucha.svg"
                  alt=""
                />
              </router-link>
            </div>

            <div
              class="hw-header__hucha-responsive header__hucha-responsive"
              v-else-if="showLittlePigNoContributions && !hidePiggyBank"
            >
              <router-link to="/mi-hucha/crear">
                <img
                  class="hw-header__icon header-nav-icon"
                  src="../../assets/img/ico/ico-nav-hucha.svg"
                  alt=""
                />
              </router-link>
            </div>

            <div v-if="showCart" class="hw-header__cart header__cart">
              <Cart />
            </div>

            <div class="hw-header__burger header__burger">
              <div class="nav-m-right">
                <button
                  type="button"
                  class="hw-header__burger-button nav-m-right__item"
                  :aria-expanded="open ? 'true' : 'false'"
                  aria-controls="hw-mobile-menu"
                  aria-label="Abrir menú"
                  @click="toggleMenu"
                >
                  <img
                    class="hw-header__icon header-nav-icon"
                    src="../../assets/img/ico/ico-burger.svg"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="300"
      class="hw-mobile-nav m-nav"
    >
      <div
        v-if="open"
        class="hw-mobile-nav__overlay m-nav__overlay"
        @click.self="closeMenu"
      >
        <transition name="hw-slide-fade">
          <div
            v-if="open"
            id="hw-mobile-menu"
            class="hw-mobile-nav__content m-nav__content"
          >
            <div class="hw-mobile-nav__header m-nav__header">
              <div @click="closeMenu" :class="{ 'w-open': open }">
                <img
                  class="hw-mobile-nav__close-icon ico-close"
                  src="../../assets/img/ico/ico-burger-close.svg"
                  alt=""
                />
              </div>
            </div>

            <div class="hw-mobile-nav__nav m-nav__nav">
              <LazyHydrate when-visible>
                <HeaderNav :headerLang="headerLang" :headerType="headerType" />
              </LazyHydrate>
            </div>

            <div class="hw-mobile-nav__login m-nav__login offnav">
              <LazyHydrate when-visible>
                <HeaderUser :headerLang="headerLang" />
              </LazyHydrate>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderNav from "./HeaderNav.vue";
import HeaderUser from "./HeaderUser.vue";
import Cart from "./Cart.vue";
import LazyHydrate from "vue-lazy-hydration";
import Features from "../../Mixins/Features";

export default {
  name: "HeaderPartial",
  components: {
    HeaderNav,
    HeaderUser,
    Cart,
    LazyHydrate,
  },
  mixins: [Features],
  props: {
    headerLang: {
      type: String,
      default: "es-ES",
    },
    headerType: {
      type: String,
      default: "",
    },
    logoScope: {
      type: String,
      default: "hellowish",
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      contributionsFlag: "contributionsFlag",
      isAuthenticated: "isAuthenticated",
      hidePiggyBank: "hidePiggyBank",
    }),

    showLittlePig() {
      return (
        this.contributionsFlag &&
        this.isAuthenticated &&
        this.user?.contributionMethods?.length > 0
      );
    },

    showLittlePigNoContributions() {
      return (
        this.contributionsFlag &&
        this.isAuthenticated &&
        this.user?.contributionMethods?.length === 0
      );
    },

    showCart() {
      const disabledLangs = [
        "fr-FR",
        "it-IT",
        "en-GB",
        "de-DE",
        "nl-NL",
        "pt-BR",
      ];

      return (
        this.featureEcommerceAvailable &&
        !disabledLangs.includes(this.headerLang)
      );
    },

    logoLink() {
      if (this.user) {
        return { name: "owner-list" };
      }

      return { name: this.$t("routes.name.home", this.headerLang) };
    },
  },
  watch: {
    $route() {
      this.closeMenu();
    },
    open(value) {
      document.body.classList.toggle("hw-menu-open", value);
    },
  },
  beforeDestroy() {
    document.body.classList.remove("hw-menu-open");
  },
  methods: {
    toggleSearch() {
      this.$store.commit("SET_SEARCHSTATE", !this.$store.state.searchState);
    },
    toggleMenu() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = false;
    },
    getImgUrl() {
      return process.env.URL_IMG_USER + this.user.photo;
    },
  },
};
</script>

<style scoped>
.hw-header-wrap {
  position: relative;
  z-index: 40;
}

.hw-header {
  position: relative;
  z-index: 50;
  background: #fff;
}

.hw-header__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 76px;
  gap: 20px;
}

.hw-header__logo {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.hw-header__logo a {
  display: inline-flex;
  align-items: center;
}

.hw-header__logo img {
  display: block;
  height: 40px;
  width: auto;
  max-width: 100%;
}

.hw-header__nav {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.hw-header__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 0 0 auto;
}

.hw-header__user--desktop {
  display: flex;
  align-items: center;
}

.hw-header__hucha,
.hw-header__hucha-responsive,
.hw-header__cart {
  display: flex;
  align-items: center;
}

.hw-header__hucha a,
.hw-header__hucha-responsive a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hw-header__icon {
  display: block;
  width: 24px;
  height: 24px;
}

.hw-header__burger {
  display: none;
  align-items: center;
}

.hw-header__burger-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.hw-mobile-nav {
  position: relative;
  z-index: 120;
}

.hw-mobile-nav__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
}

.hw-mobile-nav__content {
  position: absolute;
  top: 0;
  right: 0;
  width: min(92vw, 560px);
  height: 100vh;
  background: #fff;
  overflow-y: auto;
  box-shadow: -8px 0 30px rgba(0, 0, 0, 0.08);
}

.hw-mobile-nav__header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 72px;
  padding: 0 20px;
}

.hw-mobile-nav__close-icon {
  width: 24px;
  height: 24px;
  display: block;
}

.hw-mobile-nav__nav {
  padding: 0 20px;
}

.hw-mobile-nav__login {
  padding: 24px 20px 32px;
}

.hw-slide-fade-enter-active,
.hw-slide-fade-leave-active {
  transition: all 0.28s ease;
}

.hw-slide-fade-enter,
.hw-slide-fade-leave-to {
  transform: translateX(24px);
  opacity: 0;
}

@media (max-width: 991px) {
  .hw-header__container {
    min-height: 64px;
    gap: 12px;
  }

  .hw-header__nav--desktop {
    display: none;
  }

  .hw-header__user--desktop {
    display: none;
  }

  .hw-header__burger {
    display: flex;
  }

  .hw-header__logo img {
    height: 34px;
  }
}

@media (max-width: 575px) {
  .hw-header__container {
    min-height: 40px;
    gap: 10px;
  }

  .hw-header__right {
    gap: 8px;
  }

  .hw-header__logo img {
    height: 32px;
  }

  .hw-header__icon {
    width: 23px;
    height: 23px;
  }

  .hw-mobile-nav__content {
    width: calc(100vw - 48px);
  }

  .hw-mobile-nav__header {
    min-height: 64px;
    padding: 0 16px;
  }

  .hw-mobile-nav__nav {
    padding: 0 16px;
  }

  .hw-mobile-nav__login {
    padding: 24px 16px 32px;
  }
}
</style>

<style>
body.hw-menu-open {
  overflow: hidden;
}
</style>
